<template>
  <div class="parallaxe-title">
    <slot></slot>
  </div>
</template>

<script>
import getAbsoluteBoundingRect from '@/utils/getAbsoluteBoundingRect.js'
import MathUtils from '@/utils/MathUtils'
import EventHub from '@/utils/EventHub'

export default {
  name: 'app-parallaxe-title',

  props: {

  },

  computed: {
 
  },

  data() {
    return {

    }
  },

  created()
  {
    this.addEventListeners()
  },

  mounted()
  {
    this.initParallaxe()
  },

  destroyed()
  {
    this.removeEventListeners()
  },

  methods: {
    addEventListeners()
    {
      EventHub.$on('window:resize', this.onResize)
      EventHub.$on('application:on-scroll', this.onScroll)
      EventHub.$on('application:on-tick', this.onTick)
    },

    removeEventListeners()
    {
      EventHub.$off('window:resize', this.onResize)
      EventHub.$off('application:on-scroll', this.onScroll)
      EventHub.$off('application:on-tick', this.onTick)
    },

    initParallaxe()
    {
      this.currentScroll = 0
      this.progress = 0

      this.parallaxe = {
        amplitude: 150
      }

      this.limits = {}

      this.onResize({width: window.innerWidth, height: window.innerHeight})
      this.onScroll(window.scrollY)
    },

    onResize(windowObj)
    {
      this.windowObj = windowObj
      this.bounds = getAbsoluteBoundingRect(this.$el)
      this.limits.top = 0
      this.limits.bottom = this.bounds.bottom
    },

    onScroll(scrollY)
    {
      this.currentScroll = scrollY

       // Todo  clamp 0 to 1
      this.progress = MathUtils.clamp((scrollY - this.limits.top) / (this.limits.bottom - this.limits.top), 0, 1)
    },

    onTick()
    {
      if(this.currentScroll >= this.limits.top && this.currentScroll <= this.limits.bottom )
      {
        let val = this.progress * this.parallaxe.amplitude
  
        this.$el.style.transform = `translate3d(0, ${-val}px, 0)`  
      }
    }
  }
}
</script>

<style lang="stylus">
</style>